export default __webpack_public_path__ + "static/media/step2-frictionless.5a715bcc.gif";